import { render, staticRenderFns } from "./ChatSend.vue?vue&type=template&id=050433f2&scoped=true"
import script from "./ChatSend.vue?vue&type=script&lang=js"
export * from "./ChatSend.vue?vue&type=script&lang=js"
import style0 from "./ChatSend.vue?vue&type=style&index=0&id=050433f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050433f2",
  null
  
)

export default component.exports